import {
  API,
  BASE_URL_API_V1,
  axiosClient,
} from "../../../Constant/apiConstant";

export const workflowService = async (data) => {
  try {
    const res = await axiosClient.put(
      `${BASE_URL_API_V1}${API.V1.WORKFLOW.WORKFLOW_DATA}`,
      data
    );
    return res?.data;
  } catch (err) {
    console.log(err);
  }
};

export const getWorkflowsService = async (params) => {
  try {
    const res = await axiosClient.get(
      `${BASE_URL_API_V1}${API.V1.WORKFLOW.WORKFLOW_DATA}`,
      { params }
    );
    return res?.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const addLeadsToWorkflowsService = async (data) => {
  try {
    let res = await axiosClient.post(
      `${BASE_URL_API_V1}${API.V1.WORKFLOW.ADD_CONTACTS_TO_WORKFLOWS}`,
      data
    );
    return res?.data;
  } catch (err) {
    console.log(err);
  }
};
